export default __webpack_public_path__ + "static/media/arrow-left.ab6edc10.svg";